import { CreditsPageNavItemTabs, NavItemEnum } from '../constants/routing/NavItems';
import { useAppSelector } from '../reducers';
import { isUngatedForCommerceHubInbound25Selector, isUngatedForInbound25Selector } from '../selectors/GatingSelectors';
import { highestProductLevelFromProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { useGlobalLoading } from './loadingHooks';
import { useShouldHideOpsOrSuitePage } from './useShouldHideOpsOrSuitePage';
const useCreditsPageNavItemTabs = () => {
  const isAppReady = useGlobalLoading();
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  const isUngatedForCommerceHubInbound25 = useAppSelector(isUngatedForCommerceHubInbound25Selector);
  const highestProductLevelOwned = useAppSelector(state => {
    if (!isAppReady) return null;
    return highestProductLevelFromProductInventorySelector(state);
  });
  const shouldHideOpsOrSuitePage = useShouldHideOpsOrSuitePage();
  const isFreeOrProspect = highestProductLevelOwned === 'FREE';
  if (isFreeOrProspect && isUngatedForInbound) {
    return CreditsPageNavItemTabs.filter(tab => {
      // If not ungated for commerce hub, don't show commerce hub tab or allow access to commerce tab.
      if (!isUngatedForCommerceHubInbound25 && tab === NavItemEnum.COMMERCE) {
        return false;
      }

      // If pre-seats, filter out data (operations) and suite tabs since ops hub is no longer available
      if (shouldHideOpsOrSuitePage && (tab === NavItemEnum.DATA || tab === NavItemEnum.SUITE)) {
        return false;
      }
      return true;
    });
  }
  return [];
};
export default useCreditsPageNavItemTabs;